import _extends from '@babel/runtime/helpers/esm/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React from 'react';
import { CriticalIcon, CheckmarkBackgroundSmIcon, ClockIcon, CriticalSmIcon, PreferredSelectedIcon } from '@paypalcorp/pp-react-icons';
import { devWarning, cx } from '@paypalcorp/pp-react-utils';
import { screenReaderStyles } from '@paypalcorp/pp-react-screen-reader';
import * as styles from './styles.css';
export { styles as badgeStyles };

var _excluded = ["type", "status", "className", "leftIcon", "leftIconLabel", "children", "size", "contrast"],
  _excluded2 = ["className", "size", "children", "label", "icon"];
var badgeTypes = ['feature', 'success', 'warning', 'critical', 'neutral', 'overlay', 'highlight'];
var Badge = function (_ref) {
  var _styles$sizeStyles$si, _styles$contrastColor;
  var type = _ref.type;
    _ref.status;
    var className = _ref.className,
    leftIcon = _ref.leftIcon,
    leftIconLabel = _ref.leftIconLabel,
    children = _ref.children,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'large' : _ref$size,
    _ref$contrast = _ref.contrast,
    contrast = _ref$contrast === void 0 ? 'high' : _ref$contrast,
    rest = _objectWithoutProperties(_ref, _excluded);
  if (!badgeTypes.includes(type)) {
    devWarning("Required prop 'type' should have one of the values of [".concat(badgeTypes.join(', '), "]"));
  }
  var badgeClasses = cx((_styles$sizeStyles$si = styles.sizeStyles[size]) !== null && _styles$sizeStyles$si !== void 0 ? _styles$sizeStyles$si : styles.sizeStyles['large'], (_styles$contrastColor = styles.contrastColorStyles[contrast][type]) !== null && _styles$contrastColor !== void 0 ? _styles$contrastColor : styles.contrastColorStyles['high'][type], (leftIcon || leftIconLabel) && styles.leftIcon, className);
  var ariaProps = {
    'aria-hidden': true
  };
  var badgeIcon = (leftIcon || leftIconLabel) && /*#__PURE__*/React.createElement("span", {
    className: styles.icon,
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement(function Icon() {
    /* istanbul ignore next */
    if (type === 'critical') {
      return /*#__PURE__*/React.createElement(CriticalIcon, _extends({
        size: "xs"
      }, ariaProps, {
        "data-ppui": "true"
      }));
    }
    return /*#__PURE__*/React.createElement(leftIcon, _extends({
      size: "xs"
    }, ariaProps, {
      "data-ppui": "true"
    }));
  }, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement("span", {
    className: screenReaderStyles.screenReader,
    "data-ppui": "true"
  }, leftIconLabel));
  return /*#__PURE__*/React.createElement("span", _extends({
    className: badgeClasses,
    "data-ppui-info": "badge_4.2.3__8.5.0"
  }, rest), badgeIcon, children);
};
var AuthorizedBadge = function (props) {
  return /*#__PURE__*/React.createElement(BadgeComponent, _extends({}, props, {
    className: cx(styles.authorized, props.className),
    icon: /*#__PURE__*/React.createElement(CheckmarkBackgroundSmIcon, {
      size: "xs",
      "aria-hidden": "true",
      "data-ppui": "true"
    }),
    "data-ppui": "true"
  }));
};
var InProgressBadge = function (props) {
  return /*#__PURE__*/React.createElement(BadgeComponent, _extends({}, props, {
    className: cx(styles.inProgress, props.className),
    icon: /*#__PURE__*/React.createElement(ClockIcon, {
      size: "xs",
      "aria-hidden": "true",
      "data-ppui": "true"
    }),
    "data-ppui": "true"
  }));
};
var OnHoldBadge = function (props) {
  return /*#__PURE__*/React.createElement(BadgeComponent, _extends({}, props, {
    className: cx(styles.onHold, props.className),
    icon: /*#__PURE__*/React.createElement(CriticalSmIcon, {
      size: "xs",
      "aria-hidden": "true",
      "data-ppui": "true"
    }),
    "data-ppui": "true"
  }));
};
var FavoriteBadge = function (props) {
  return /*#__PURE__*/React.createElement(BadgeComponent, _extends({}, props, {
    className: cx(styles.favorite, props.className),
    icon: /*#__PURE__*/React.createElement(PreferredSelectedIcon, {
      size: "xs",
      "aria-hidden": "true",
      "data-ppui": "true"
    }),
    "data-ppui": "true"
  }));
};
var NumericBadge = function (props) {
  //@ts-ignore
  var numericProp = parseInt(props.children, 10);
  if (!numericProp) {
    devWarning('Numeric Badge is missing the value.');
    numericProp = 0;
  }
  if (numericProp < 0) {
    devWarning('Numeric badge accept value >= 0.');
    numericProp = Math.abs(numericProp);
  }
  var displayValue = numericProp > 9 ? '9+' : numericProp.toString();
  return /*#__PURE__*/React.createElement(BadgeComponent, _extends({}, props, {
    className: styles.numeric,
    "data-ppui": "true"
  }), displayValue);
};
var BadgeComponent = function (_ref2) {
  var className = _ref2.className,
    _ref2$size = _ref2.size,
    size = _ref2$size === void 0 ? 'large' : _ref2$size,
    children = _ref2.children,
    label = _ref2.label,
    icon = _ref2.icon,
    rest = _objectWithoutProperties(_ref2, _excluded2);
  var badgeClasses = cx(styles.sizeStyles[size], className);
  return /*#__PURE__*/React.createElement("span", _extends({
    className: badgeClasses,
    "data-ppui-info": "badge_4.2.3__8.5.0"
  }, rest), icon, icon ? /*#__PURE__*/React.createElement("span", {
    className: screenReaderStyles.screenReader,
    "data-ppui": "true"
  }, label) : children);
};

export { AuthorizedBadge, Badge, FavoriteBadge, InProgressBadge, NumericBadge, OnHoldBadge };
